import request from '@/util/http'
// import qs from 'qs'

// 导航列表查询
export const getNavigationPage=(params)=>request({
    url: '/admin/navigation/page',
    method: 'get',
    params
})

// 导航单个删除
export const handleNavigationDelete=(id)=>request({
    url: `/admin/navigation/delete/${id}`,
    method: 'delete'
})
// 导航详情
export const getNavigationInfo=(id)=>request({
    url: `/admin/navigation/get/${id}`,
    method: 'get'
})

// 保存导航
export const hallSaveOrUpdate=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/navigation/saveOrUpdate',
    method: 'post',
    data:JSON.stringify(data)
})
